import React__default, { createElement, useState, useRef, useEffect } from 'react';
import { Image, Box, Flex, Link, Text, Button } from 'rebass';
import styled, { createGlobalStyle } from 'styled-components';
import format from 'date-fns/format';
import { normalize } from 'styled-normalize';
import debounce from 'lodash-es/debounce';

var SvgLogo = function SvgLogo(props) {
  return createElement(Image, Object.assign({
    height: "30px"
  }, props, {
    src: "https://0f14676b303fd91881eb-98dd17e178263eba3c55ca6434a72b9d.ssl.cf5.rackcdn.com/img/redesign2020/asset-logo@3x.png"
  }));
};

var SvgAssetIconFacebook = function SvgAssetIconFacebook(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 32 32"
  }, props), createElement("path", {
    fill: "#4C5761",
    fillRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16zm17.134 8.874V16.17h2.403l.319-3h-2.722l.004-1.5c0-.783.075-1.202 1.199-1.202h1.502v-3h-2.404c-2.886 0-3.902 1.455-3.902 3.902v1.801h-1.8v3h1.8v8.704h3.601z"
  }));
};

var SvgAssetIconLinkedIn = function SvgAssetIconLinkedIn(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 32 32"
  }, props), createElement("path", {
    fill: "#4C5761",
    fillRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16zm11.307-2.748H7.681v10.894h3.626V13.252zm.239-3.37C11.522 8.814 10.758 8 9.518 8s-2.051.814-2.051 1.882c0 1.046.787 1.883 2.004 1.883h.023c1.264 0 2.052-.837 2.052-1.883zM24.384 17.9c0-3.346-1.79-4.904-4.175-4.904-1.925 0-2.787 1.057-3.269 1.8v-1.544h-3.626c.048 1.022 0 10.895 0 10.895h3.626v-6.085c0-.325.024-.65.12-.883.262-.65.859-1.324 1.86-1.324 1.313 0 1.838.999 1.838 2.463v5.828h3.625V17.9z"
  }));
};

var SvgAssetIconTwitter = function SvgAssetIconTwitter(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 32 32"
  }, props), createElement("path", {
    fill: "#4C5761",
    fillRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16zm15.52-2.995l.034.554-.56-.068c-2.036-.26-3.816-1.141-5.326-2.621l-.74-.735-.19.542c-.402 1.21-.145 2.486.695 3.345.447.474.346.542-.426.26-.268-.09-.503-.158-.526-.125-.078.08.19 1.108.403 1.514.291.565.884 1.12 1.533 1.447l.549.26-.65.01c-.626 0-.648.012-.581.25.224.734 1.108 1.513 2.093 1.852l.693.238-.604.361a6.301 6.301 0 0 1-3 .836c-.503.012-.917.057-.917.09 0 .114 1.365.746 2.16.995 2.384.734 5.215.418 7.342-.836 1.51-.893 3.021-2.667 3.727-4.384.38-.915.76-2.587.76-3.39 0-.52.034-.587.66-1.209.37-.361.717-.757.784-.87.112-.214.101-.214-.47-.022-.951.339-1.085.294-.615-.215.347-.361.76-1.017.76-1.209 0-.034-.167.023-.357.125-.202.113-.65.282-.985.384l-.605.192-.548-.373c-.302-.203-.727-.43-.951-.497-.571-.158-1.444-.136-1.959.045-1.399.508-2.283 1.82-2.182 3.254z"
  }));
};

var Divider =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "desktop-footer__Divider",
  componentId: "jymb7q-0"
})(["height:1px;border:solid 1px rgba(76,87,97,0.5);background-color:#eaeaea;"]);
var FooterText =
/*#__PURE__*/
styled(Text).withConfig({
  displayName: "desktop-footer__FooterText",
  componentId: "jymb7q-1"
})(["font-family:'Work Sans',sans-serif;font-size:16px;letter-spacing:'-0.7px';color:#4c5761;"]);

var SocialLinks = function SocialLinks(_ref) {
  var onLinkClicked = _ref.onLinkClicked;
  return React__default.createElement(Flex, {
    width: "140px",
    justifyContent: "space-between"
  }, React__default.createElement(Link, {
    href: "https://www.facebook.com/MDLinx",
    onClick: function onClick() {
      return onLinkClicked({
        name: 'Facebook',
        route: 'https://www.facebook.com/MDLinx'
      });
    },
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(SvgAssetIconFacebook, {
    width: 32,
    height: 32
  })), React__default.createElement(Link, {
    href: "https://twitter.com/mdlinx",
    onClick: function onClick() {
      return onLinkClicked({
        name: 'Twitter',
        route: 'https://twitter.com/mdlinx'
      });
    },
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(SvgAssetIconTwitter, {
    width: 32,
    height: 32
  })), React__default.createElement(Link, {
    href: "https://www.linkedin.com/company/mdlinx",
    onClick: function onClick() {
      return onLinkClicked({
        name: 'LinkedIn',
        route: 'https://www.linkedin.com/company/mdlinx'
      });
    },
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(SvgAssetIconLinkedIn, {
    width: 32,
    height: 32
  })));
};

var DesktopFooter = function DesktopFooter(_ref2) {
  var desktopFooterLinks = _ref2.desktopFooterLinks,
      _onLinkClicked = _ref2.onLinkClicked;
  return React__default.createElement(Box, {
    py: "25px"
  }, React__default.createElement(Flex, null, React__default.createElement(Flex, {
    flexDirection: "column"
  }, React__default.createElement(SvgLogo, {
    width: "140px",
    height: "33px"
  }), React__default.createElement(Box, {
    my: "12px"
  }), React__default.createElement(FooterText, {
    lineHeight: 1.5
  }, "FIND US ON:"), React__default.createElement(Box, {
    my: "7px"
  }), React__default.createElement(Box, null, React__default.createElement(SocialLinks, {
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked(link);
    }
  }))), React__default.createElement(Flex, {
    mx: "40px",
    width: "100%",
    justifyContent: "center",
    style: {
      maxWidth: '820px'
    }
  }, React__default.createElement(Flex, {
    justifyContent: "space-between",
    width: "100%",
    mx: "40px",
    style: {
      maxWidth: '500px'
    }
  }, React__default.createElement(Flex, {
    flexDirection: "column"
  }, desktopFooterLinks.set1.map(function (link) {
    return React__default.createElement(Link, {
      href: link.route,
      key: link.name,
      onClick: function onClick() {
        return _onLinkClicked(link);
      },
      style: {
        cursor: 'pointer',
        textDecoration: 'none'
      }
    }, React__default.createElement(FooterText, {
      lineHeight: 1.75
    }, link.name));
  })), React__default.createElement(Flex, {
    flexDirection: "column"
  }, desktopFooterLinks.set2.map(function (link) {
    return React__default.createElement(Link, {
      href: link.route,
      key: link.name,
      onClick: function onClick() {
        return _onLinkClicked(link);
      },
      style: {
        cursor: 'pointer',
        textDecoration: 'none'
      }
    }, React__default.createElement(FooterText, {
      lineHeight: 1.75
    }, link.name));
  }))))), React__default.createElement(Box, {
    my: "20px"
  }), React__default.createElement(Box, null, React__default.createElement(Divider, null), React__default.createElement(Box, {
    my: "12px"
  }), React__default.createElement(FooterText, {
    lineHeight: 1.31
  }, "\xA9 " + format(new Date(), 'YYYY') + " M3 USA Corporation. All Rights Reserved.")));
};

var Divider$1 =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "mobile-footer__Divider",
  componentId: "sc-9tudk0-0"
})(["width:233px;height:1px;border:solid 1px rgba(76,87,97,0.5);background-color:#eaeaea;"]);
var VerticalDivider =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "mobile-footer__VerticalDivider",
  componentId: "sc-9tudk0-1"
})(["height:16px;width:1px;background-color:#4c5761;"]);

var MobileFooter = function MobileFooter(_ref) {
  var mobileFooterLinks = _ref.mobileFooterLinks,
      _onLinkClicked = _ref.onLinkClicked;
  return React__default.createElement(Box, {
    p: "40px 20px 20px 20px",
    style: {
      maxWidth: '480px'
    }
  }, React__default.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, React__default.createElement(SvgLogo, {
    width: "140px",
    height: "33px"
  }), React__default.createElement(Box, {
    my: "12px"
  }), React__default.createElement(Box, null, React__default.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    lineHeight: 1.5,
    letterSpacing: "-0.7px",
    color: "#4c5761"
  }, "FIND US ON:"), React__default.createElement(Box, {
    my: "7px"
  }), React__default.createElement(Box, null, React__default.createElement(SocialLinks, {
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked(link);
    }
  })), React__default.createElement(Box, {
    my: "14px"
  }), React__default.createElement(Box, null, React__default.createElement(MobileFooterLinks, {
    mobileFooterLinks: mobileFooterLinks,
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked(link);
    }
  })), React__default.createElement(Box, {
    my: "11.5px"
  }), React__default.createElement(Divider$1, null), React__default.createElement(Box, {
    my: "11.5px"
  }), React__default.createElement(Box, {
    style: {
      maxWidth: '298px'
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    lineHeight: 1.31,
    letterSpacing: "-0.7px",
    color: "#4c5761",
    textAlign: "center"
  }, "\xA9 " + format(new Date(), 'YYYY') + " M3 USA Corporation. All Rights Reserved."))))));
};

var MobileFooterLinks = function MobileFooterLinks(_ref2) {
  var mobileFooterLinks = _ref2.mobileFooterLinks,
      onLinkClicked = _ref2.onLinkClicked;
  return React__default.createElement(Flex, {
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "center"
  }, mobileFooterLinks.map(function (link, i) {
    return React__default.createElement(Link, {
      href: link.route,
      key: link.name + i,
      onClick: function onClick(e) {
        e.preventDefault();
        onLinkClicked(link);
      }
    }, React__default.createElement(Flex, {
      alignItems: "center"
    }, React__default.createElement(Text, {
      fontFamily: "'Work Sans', sans-serif",
      style: {
        cursor: 'pointer'
      },
      fontSize: "16px",
      lineHeight: 1.75,
      letterSpacing: "-0.7px",
      color: "#4c5761",
      textAlign: "center"
    }, link.name), i < mobileFooterLinks.length - 1 && React__default.createElement(VerticalDivider, {
      mx: "10px"
    })));
  }));
};

var breakpoints = {
  xs: '@media screen and (max-width: 479px)',
  sm: '@media screen and (min-width: 480px) and (max-width: 767px)',
  md: '@media screen and (min-width: 768px) and (max-width: 1023px)',
  lg: '@media screen and (min-width: 1024px) and (max-width: 1279px)',
  xl: '@media screen and (min-width: 1280px)'
};

var hidden = function hidden(key) {
  return function (props) {
    var _ref;

    return props[key] ? (_ref = {}, _ref[breakpoints[key]] = {
      display: 'none'
    }, _ref) : null;
  };
};

var xs =
/*#__PURE__*/
hidden('xs');
var sm =
/*#__PURE__*/
hidden('sm');
var md =
/*#__PURE__*/
hidden('md');
var lg =
/*#__PURE__*/
hidden('lg');
var xl =
/*#__PURE__*/
hidden('xl');
var Hide =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "hide__Hide",
  componentId: "sc-1uwvgl9-0"
})(["", ";", ";", ";", ";", ";", ""], xs, sm, md, lg, xl, function (props) {
  return props.at && "@media screen and (max-width: " + props.at + "px) {display: none}";
});

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["  \n", "\n  body {\n    @import url('https://fonts.googleapis.com/css?family=Work+Sans&display=swap');\n    font-family: 'Work Sans', sans-serif;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = createGlobalStyle(_templateObject(), normalize);
var theme = {
  breakpoints: ['320px', '480px', '768px', '1024px', '1280px']
};

var Footer = function Footer(_ref) {
  var footerLinks = _ref.footerLinks,
      _onLinkClicked = _ref.onLinkClicked;
  return React__default.createElement(Flex, {
    bg: "#eaeaea",
    width: "100%",
    justifyContent: "center"
  }, React__default.createElement(Box, {
    width: "100%",
    style: {
      maxWidth: 1280
    }
  }, React__default.createElement(Box, {
    px: [15, 15, 20, 30, 30, 40]
  }, React__default.createElement(Hide, {
    xs: true,
    sm: true
  }, React__default.createElement(DesktopFooter, {
    desktopFooterLinks: footerLinks.desktop,
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked(link);
    }
  })), React__default.createElement(Hide, {
    md: true,
    lg: true,
    xl: true
  }, React__default.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center"
  }, React__default.createElement(MobileFooter, {
    mobileFooterLinks: footerLinks.mobile,
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked(link);
    }
  }))))));
};

var useWindowSize = function useWindowSize() {
  var _React$useState = React__default.useState({
    width: window.innerWidth,
    height: window.innerHeight
  }),
      size = _React$useState[0],
      setSize = _React$useState[1];

  var onResize = debounce(function () {
    return setSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }, 500);
  React__default.useEffect(function () {
    window.addEventListener('resize', onResize, true);
    return function () {
      window.removeEventListener('resize', onResize, true);
    };
  }, []);
  return size;
};

var ListItemDivider =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "user-profile-menu__ListItemDivider",
  componentId: "sc-1l3v7jf-0"
})(["height:1px;background-color:#e7e3cf;"]);
var LiText =
/*#__PURE__*/
styled(Text).withConfig({
  displayName: "user-profile-menu__LiText",
  componentId: "sc-1l3v7jf-1"
})(["font-family:'Work Sans',sans-serif;font-size:13px;line-height:1.69;letter-spacing:-0.08px;color:#202529;"]);

var UserProfileMenuListItem = function UserProfileMenuListItem(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      route = _ref.route;
  return React__default.createElement(Link, {
    href: route && route,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick && _onClick();
    },
    style: {
      textDecoration: 'none'
    }
  }, React__default.createElement(Flex, {
    alignItems: "center",
    py: [20, 20, 20, 20, 10, 10],
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.57,
    letterSpacing: "-0.3px",
    color: "#202529"
  }, children)));
};

var UserProfileMenuLogIn = function UserProfileMenuLogIn(_ref2) {
  var onProfileLinkClick = _ref2.onProfileLinkClick;
  return React__default.createElement(Box, null, React__default.createElement(Box, {
    px: "15px"
  }, React__default.createElement(UserProfileMenuListItem, {
    onClick: function onClick() {
      return onProfileLinkClick({
        name: 'login',
        route: ''
      });
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.38,
    letterSpacing: "-0.3px",
    color: "#202529"
  }, React__default.createElement(Text, {
    as: "span",
    color: "#004577",
    style: {
      textDecoration: 'underline'
    }
  }, "Log in"), ' ', "to access your account."))), React__default.createElement(ListItemDivider, {
    mx: "15px"
  }), React__default.createElement(Box, {
    my: "44px"
  }), React__default.createElement(Box, {
    px: "15px"
  }, React__default.createElement(SignUp, {
    onClick: function onClick() {
      return onProfileLinkClick({
        name: 'SignUp',
        route: ''
      });
    }
  })));
};

var SignUp = function SignUp(_ref3) {
  var _onClick2 = _ref3.onClick;
  return React__default.createElement(Box, null, React__default.createElement(Box, null, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.38,
    letterSpacing: "-0.3px",
    color: "#202529"
  }, "Don\u2019t have an account yet?"), React__default.createElement(Box, {
    style: {
      height: '19.5px'
    }
  }), React__default.createElement("ul", {
    style: {
      paddingLeft: 25
    }
  }, React__default.createElement("li", {
    style: {
      paddingLeft: 10
    }
  }, React__default.createElement(LiText, null, "Get unlimited fast access to the latest medical news and findings in your field")), React__default.createElement(Box, {
    my: "10px"
  }), React__default.createElement("li", {
    style: {
      paddingLeft: 10
    }
  }, React__default.createElement(LiText, null, "Play Smartest Doc for bragging rights on our national leaderboard and win a trophy for your desk.")))), React__default.createElement(Box, {
    my: "28.5px"
  }), React__default.createElement(Box, {
    mb: "15px"
  }, React__default.createElement(Button, {
    onClick: function onClick() {
      return _onClick2();
    },
    py: "20.5px",
    width: "100%",
    border: "solid 3px #5f6367",
    bg: "white",
    style: {
      cursor: 'pointer'
    },
    borderRadius: "0px"
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    color: "rgba(0, 0, 0, 0.7)"
  }, "Sign Up"))));
};

var UserMessageLitItem = function UserMessageLitItem(_ref4) {
  var message = _ref4.message,
      _onClick3 = _ref4.onClick,
      id = _ref4.id;
  return React__default.createElement(Box, {
    id: id,
    onClick: function onClick() {
      return _onClick3();
    },
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Box, {
    py: [20, 20, 20, 20, 10, 10]
  }, React__default.createElement(Box, null, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "13px",
    fontWeight: 500,
    lineHeight: 1.38,
    color: "#131824"
  }, message.title)), message.jobNumber && React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "13px",
    lineHeight: 1.38,
    color: "#9da38d"
  }, "(" + message.jobNumber + ")"), message.companyName && React__default.createElement(React__default.Fragment, null, React__default.createElement(Box, {
    mt: "9.5px"
  }), React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "11px",
    color: "#5f6367"
  }, "\xA9" + format(new Date(), 'YYYY') + " " + message.companyName + " All rights reserved."))));
};

var UserProfileMenu = function UserProfileMenu(_ref5) {
  var profileLinks = _ref5.profileLinks,
      onProfileLinkClick = _ref5.onProfileLinkClick,
      userMessages = _ref5.userMessages,
      numberUnreadMessages = _ref5.numberUnreadMessages,
      profileName = _ref5.profileName;

  var _useWindowSize = useWindowSize(),
      height = _useWindowSize.height;

  return React__default.createElement(Box, {
    style: {
      overflow: 'auto'
    }
  }, React__default.createElement(Box, {
    style: {
      maxHeight: height - 100 + "px"
    }
  }, React__default.createElement(Box, null, React__default.createElement(Box, {
    px: "15px",
    py: "20px"
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.38,
    letterSpacing: "-0.3px",
    color: "#202529"
  }, profileName)), React__default.createElement(ListItemDivider, null), React__default.createElement(Box, {
    p: "15px"
  }, React__default.createElement(Link, {
    id: "my-messages-link",
    href: profileLinks.messages.route,
    pb: "11px",
    onClick: function onClick(e) {
      e.preventDefault();
      onProfileLinkClick(profileLinks.messages);
    },
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: 1.57,
    letterSpacing: "-0.3px",
    color: "#202529"
  }, "My Messages", ' ', React__default.createElement(Text, {
    as: "span",
    fontFamily: "'Work Sans', sans-serif",
    color: "#df0b0b"
  }, numberUnreadMessages ? "(" + numberUnreadMessages + ")" : null)))), React__default.createElement(ListItemDivider, null), React__default.createElement(Box, {
    bg: "#faf9f3",
    pl: "15px",
    pr: "30.5px"
  }, userMessages.slice(0, 3).map(function (message, i) {
    return React__default.createElement(Box, {
      key: message.id
    }, React__default.createElement(UserMessageLitItem, {
      id: "message-" + i,
      message: message,
      onClick: function onClick() {
        return onProfileLinkClick({
          name: 'message',
          route: "/message_detail.cfm?m_id=" + message.id + "#&rf=dropdown"
        });
      }
    }), i < userMessages.slice(0, 3).length - 1 && React__default.createElement(ListItemDivider, null));
  }))), React__default.createElement(ListItemDivider, null), profileLinks.links.map(function (profileLink, i) {
    return React__default.createElement(Box, {
      px: "15px",
      key: profileLink.name + i
    }, React__default.createElement(UserProfileMenuListItem, {
      route: profileLink.route,
      onClick: function onClick() {
        return onProfileLinkClick(profileLink);
      }
    }, profileLink.name), i + 1 < profileLinks.links.length && React__default.createElement(ListItemDivider, null));
  }), React__default.createElement(Box, {
    mt: "19px"
  }), React__default.createElement(Box, {
    mx: "15px",
    mb: "15px"
  }, React__default.createElement(Button, {
    onClick: function onClick() {
      return onProfileLinkClick({
        name: 'SignOut',
        route: ''
      });
    },
    py: "20.5px",
    width: "100%",
    border: "solid 3px #5f6367",
    bg: "white",
    borderRadius: "0px",
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    color: "rgba(0, 0, 0, 0.7)"
  }, "Sign Out")))));
};

var SvgUserAvatarLoggedIn = function SvgUserAvatarLoggedIn(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 102 99"
  }, props), createElement("image", {
    width: 102,
    height: 99,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABjCAYAAABpEnXRAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAN JElEQVR42u1da3BV13lda59zr16IAWOMwYK4ARpCjMEQ2xDHNZlJ3DYZ8fJcGzBQRWhEa8+k9Uwm k4lnOncyTeMm445bT1uqYks2xmCpMRimITN9JCV9pDYPY2w5NrYLRhg3BoMR6HHvOXv1B4MsCT2u dO8+5/JYPxgknfOt/e119j778e3vEJcBJHHJhg1lpdlsRVfgjTFdwRhrUGGIhKzx4Vlf1viS9T0g DMCQxgakCYyQFUynNeG5pEmeC5LBuZL29o6WlpYwbr+GAuMuwECQxDVrvlXZpfPXd2d5PY0mSNYv mNOkYHgGsCeB5MnS4PTpYhOqaISRxCWrN0zwmKlSwEkhlIyK2xjPSuGphO+3fTyz6sNfpNNB3PUR uzCp1ENjuvygyoRBVQhbFnd5AITGeCdKQtvW3Pz0SZKKoxCxCbOspmZc2ImZEm6MqwzDwTdoTyRL Dzc/83cfRC1Q5MIsX7duQtBtZkqYGDX3qGHUwWTJ4QWfndKWTqdtFJSRCVNdX1+OTzJfKOYWMhzo 8XxpgEMtLY0fOedyTZBOp83et49M9wLMDAHPNV8U8H3/g3HJ4I2mpqYuVxxOhVlWUzPOdpjbLOwY lzwxIfQNWndsazriwrgzYe5bXfvZTKjZkmIf+bmEMebEjWP9gw0NDdlC2i14paVSqWQnxs4Dw0nR VU/MMF6HXxru29HUdKZQJgva5y+pra202ZK7RDsu6rqJFVJCAad9fs5tnW+9/urZQpgsmDDfWP1H 4002u8hKJfHVUKyghBtnzV5g32o98HHexgpRoiWr6iYxDBZcKaOufEFP7+18vqk1n0lp3sIsWVk7 RdL8K/0lP1L4Po5t39J4cLTi5LVim0p9c2JXDKIYj9fJ4k4rzDDETQJvAFROoERgQKJDFmdAtQF6 H/BegcL3oixjEGDqktX1WQBvjOb+UVfospqacUEHvoSIui8jVlnDRYAWApgxirJ/RPFlGf1KoX0t qrUvk/Te3PncU++M9L5RCZNKPTQmw867oliaN8ZMDoV1hO4qmFHiKK2eFfCK6/IDAJU8uKul4f2R 3DPip31xOu37J08tspDTJXorjKNhjYA/JvCZApsfB/Ie0MwxsMcEnnLpC42dNHPuoo8OH9qb8xLO iIW59cbpc63s9W4dMbeT+HMAswEYh1Q3iLwXMKWSPUg6e1XSt3birbNntLW2tua0Uzoip6tT9dOs DascVhQI3gfgUQDlLnn6kmo5Pe9PYeiMM4Qt68TYeblen3OLWVJbW8kwe4fk5rEy9BOi/gTEMsSz gTcFxEJR+ymec8JAjZkzd37w5qEDp4etj1zsSaLaMddaOulWJFEIvwNgsZMKybkgqKL4GA0muKII Ajurur5+2JaZU4vZ33pimhjc7Kqw9Mw6APe6sj/C0pQBvIWefg6x4JEzAgwCVLx96MDxoa4bVphU Kp20/Ph2OZqvCPwdAnUubOeB6yBOBvBfTqxbjZkxe97Zw62vDtplDts1dftts1zNV+jhZlLfcuJ8 /ribxApXxhM0t6RSzYM+7EMKs3bt2gobBoWeQ/RA1tQBjCx+bKSw5ErQjHdhO4Qt60j8bNC6HVKY 05nEDId+zwd0q0P7eYNCKYlVrux7stPT6fSAGgwqTCr1SBmhqS4KJIkka1w5XOCyfg0GN7mwbUOU vvb2sQHreFBhAnN2uqtVYxreI+BmF7YdwJPMGlfGMxYzBqrnAYVJp9O+VTjNna9c7M524WGgOwjj Zm3QhuX3rd1wSazdgMIc+PXRya52IwlTRmCOEycdQUBC5AJX9rPZzCXLXAMKE5LO1sNELhCQcGXf FUjd6dD6pFQq3Wd0eokwqdQjZQjdrR67ddAdJH2RribZErvQ1meAcYkw3SVnnYxAeqGoh8hDoILQ dGfWfTu0MAzsDc7IDcslOZmwRQHRc9fFh3Z8fX19TxffR5hUKuUJbma6AECLKa5sRwNNdmn9dCbT s6rdR5guf/x4a0NnO4YyqHDpmHOIToPjg06v593eT4SM2y1j6zZOwDXkOM5BDAcWxojXxe381YzA ovLie8b0/4NLYhl2xu18PiDcl//cOW8M0EuYxem0T8dxYrQ479oxp6DcxAL0wnnb1VeYiW/8ptQ1 qQw+cM3hFjzhmsGoX4sBOt2/mK06SA4bIVKsoMI21xwBgn7ClJVEtZP4WkQ8hcZ5ge+6JqG8MqBP i7GRBIdL/J8oeAoNknsFOM83I+9CzpxPhVE0wlDaR6CgB0mjQGQPlGVfYbq7FE2Lge0UcCgSJwsE AllK+6LgMurXYjxjXAZv93f051FxFQIWfFmwkczBLm5Q9ohhjJvw1wEdtXYPgSNR8eWJkLTPRUko qZcYLHw46GAgKUlNUTo76rJK/wyL4/lbypGPFEn1aiUm6gx3+wEW9dBZRJdotkbJSWMCoFdXFtrO SNI99S2E3QQoEzVvrjDSNshGOiFmqL7CCNF1ZT2cIY5I/OuoeXPELyW8GDXpxbnSp6MyPxFLHkhC e0D8YxzcQ+AdGvtX8VCHGaD3PMZ6znJvDQeFdjOBIlkR0GlSP1DIWLpYS+8c0Ht1OdkZ214JSRHe jwD8Iq4yXCgI2kR9VxZOTzEPBR9+X2EaGxu748qYCgBWQRbSX1J4hmTkAxGQ+wB8m9b90v6Q9WBs X2FIimLsG1mCfgLgBwA6oiPldoXh92EVHecgKAmS54F+W8uhwoLk2soXsvYVa/WHAH4Kpyu6fN3I fhuwjXH2Fr0QNjf/zXmgX5KfkoR/MhOERRH7ZYgzkDYaY16y0h8A+FLBjPekLNErNv6c4D3wDE9d fED6CFPhZU5mguJKOWatPQHgsZ4kP9RCKP8kPyiOFtIHlD3Z8//+f1x6f+1XiySV+6DIOS0WdBzU UcLslazz3cd8UabknpaWhk+AAfKV0bcnEcDJEb9CwYb6GMBuApAA4MLDf/Ff9W4LAoToB3kjhfGQ bX7+78+SDRd+vsRp+bEOF69WWGtO9B6AXCLM/M9VfeQhnlnv1YxESVmfCJwBX6DfeGD9LVT4W3EX 9mqBB9O544Wn/nXIFgMAiTL38VPX8CmsZ9v6z6MGFGZHU9MZeiyKyebVgHF+eKz/7wbNIqsgfAc0 80dDRChpaW4jMQfgTYSdIrGCQNnleDC2r2/ICugkeE7ECUptkF4j/VetghGHZfm+Pti8efP5AXgG xoVvhtV+RaFyOmxEoRLEQgF3AmYueHVlLBfRRWE/gf+Gco+qCROV/757y5OX9E5Dzp6Xrvzm1NBq 3pCWDcsJrJC4FLi6xBgUYjuoF0D+FNYOugFJ4sNdLzQNmMl2yJCl22Z95rgHM6Dyhn4CBstg+Q8S 7r8mSi9QlQDqIP2t8XD3YJd5ZTg8qInhOFasqZ+cyWS+2OcmYqrAR4HL/bBrZNgP4ke9txWM8dp2 bnvqwGA3DBvk9+JzDSc8w99c/Fny7gTMj3FNlJFgPoAfk5wEAMbzstmJ5a1D3ZBT9KUdmzhkjCyI B2js9wRFl3r3SoEwVcDjJL5gFP5695NPdg91eU7C7Gpo6ID8coAPogg+anoZY6zA6u1bG48Od2HO 8crzPz91O8H/jNuzyxkE20u8ZE0uu6UjevpXPFhXlQ3DVyV3eYmvZBjPrNr5/FPbcrp2JIZf3LKp DeJaXNz6uIacYciNuYoCjOKDBrteeHo3yR/G7ehlBXLfdaXTHhnRLaPhkcQlq9Y/I2lt3D4XO0i8 S3p37dy66f9Gct+oDiuR1IJZ02pxIbzoGgbHh0nDe0cqCpDn0Le6vr4cZ4N/kbQo7hooNhD8xE/g nu3PPX1wNPfndbxvV0NDh1c69usk/yPuiigmkDhlqN8drShAAb5mtKPpiTMTSqd9jcRLcVdIMYDA +2Diyy9ta8zr9ELBZvGp5mav6ye7N6r4vmwRIfh6WUny91qe3Zj3mc2CL69UP1D7XUB/5uqzJsUK kv/klY5ds6PpiTMFseeikNWrar8sYSskp98zKwaQzAL83s6tmx4vZGC6swXJ5esenpDt7ngWwNcj qaE4QB6lZ1bu2rLpVwU37bLckrh01fo6QT+8ktbXSFoIG72ysY8Wquu6hCMKR5ave3hC0N3xmID1 UXE6A/myb8xDO57f5DS3TKSVVP1g3UKF4eNQAc+6RIfjhvz+/FnTNqXTaedR6rE8vctW1i0OZB8F 9NU4+EcE8j0D/EXJrGlNLel0ZDHdsXYry1avvyMM9R1A1QKK61tl5D5DPVGy/Pe3ttx/f+TJKYqi v1++7uEJQbbrAVi7VsDCuMpB4hjILcZo80tbGlvzt5hHWeIkHwj3rd4wM2ODpZL9CsG7BTnLBc0L B2/3g/w3D+Zn82ZV7Yni/ZFj2YoX6XTa3/vW+7cbcLG1upXE5wT9NjSabwQwAPW/BN8i8aYFf1lW 6e1pabhwtK7YUNTCDIYVD9ZVBbIzEZrxMKqERSUMKgVUUOoW0Q6hHUQ7wbOCd2RyJd5taGi4bHJx /j8ayAwtI7awhgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0wNy0xNlQwNzoxNTozOCswMzowML8a wFUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMDctMTZUMDc6MTU6MzgrMDM6MDDOR3jpAAAAAElF TkSuQmCC"
  }));
};

var SvgUserIconUnknown = function SvgUserIconUnknown(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 33 33"
  }, props), createElement("path", {
    fill: "#4C5761",
    fillRule: "evenodd",
    d: "M24.114 20h-16C3.696 20 0 23.582 0 28v2h32v-2c0-4.418-3.468-8-7.886-8m-16-10a8 8 0 1 0 16 0 8 8 0 0 0-16 0"
  }));
};

var Badge =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "user-profile-control__Badge",
  componentId: "sc-1jz3coo-0"
})(["width:23px;height:22px;background-color:#df0b0b;border-radius:50%;position:relative;left:20px;z-index:10;"]);
var AvatarContainer =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "user-profile-control__AvatarContainer",
  componentId: "sc-1jz3coo-1"
})(["position:relative;bottom:18px;"]);

var UserProfileControl = function UserProfileControl(_ref) {
  var name = _ref.name,
      isLoggedIn = _ref.isLoggedIn,
      numberUnreadMessages = _ref.numberUnreadMessages;
  return React__default.createElement(Box, {
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Flex, {
    alignItems: "center"
  }, React__default.createElement(Box, {
    width: 43,
    style: {
      height: '37px'
    }
  }, isLoggedIn ? React__default.createElement(Box, {
    width: 43,
    style: {
      height: '37px'
    }
  }, numberUnreadMessages && numberUnreadMessages > 0 ? React__default.createElement(React__default.Fragment, null, React__default.createElement(Badge, null, React__default.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center",
    style: {
      height: '100%'
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: 1.5,
    color: "#ffffff"
  }, numberUnreadMessages))), React__default.createElement(AvatarContainer, null, React__default.createElement(SvgUserAvatarLoggedIn, {
    width: "34px",
    height: "34px"
  }))) : React__default.createElement(Box, {
    pt: "4px",
    pr: "9px"
  }, React__default.createElement(SvgUserAvatarLoggedIn, {
    width: "34px",
    height: "34px"
  }))) : React__default.createElement(Box, {
    pt: "4px"
  }, React__default.createElement(SvgUserIconUnknown, {
    width: "34px",
    height: "34px"
  }))), React__default.createElement(Hide, {
    xs: true,
    sm: true,
    md: true
  }, React__default.createElement(Box, {
    width: "9px"
  })), React__default.createElement(Hide, {
    xs: true,
    sm: true,
    md: true
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    color: "#4c5761",
    pt: "4px"
  }, isLoggedIn ? name : 'Sign up / Log in'))));
};

var SvgAssetMenuIcon = function SvgAssetMenuIcon(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), createElement("defs", null, createElement("path", {
    id: "asset-menu-icon_svg__a",
    d: "M0 14h18v-2H0v2zm0-6h18V6H0v2zm0-8v2h18V0H0z"
  })), createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, createElement("path", {
    d: "M0 0h24v24H0z"
  }), createElement("g", {
    transform: "translate(3 5)"
  }, createElement("mask", {
    id: "asset-menu-icon_svg__b",
    fill: "#fff"
  }, createElement("use", {
    xlinkHref: "#asset-menu-icon_svg__a"
  })), createElement("g", {
    fill: "#4C5761",
    mask: "url(#asset-menu-icon_svg__b)"
  }, createElement("path", {
    d: "M-49.905-52.507h122v122h-122z"
  })))));
};

var SvgAssetIconCrossLarge = function SvgAssetIconCrossLarge(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 48 48"
  }, props), createElement("path", {
    d: "M0 0l48 48M0 48L48 0",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#1C273F",
    strokeWidth: 1.5
  }));
};

var Container =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "header__Container",
  componentId: "sc-1axebe7-0"
})(["max-width:1280px;"]);
var CloseIcon =
/*#__PURE__*/
styled(SvgAssetIconCrossLarge).withConfig({
  displayName: "header__CloseIcon",
  componentId: "sc-1axebe7-1"
})(["width:16px;height:16px;cursor:pointer;"]);
var Divider$2 =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "header__Divider",
  componentId: "sc-1axebe7-2"
})(["width:100%;margin-top:0.1px;margin-bottom:0.1px;height:0.8px;background-color:", ";"], function (prop) {
  return prop.color ? prop.color : '#eaeaea';
});
var UserProfileMenuContainer =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "header__UserProfileMenuContainer",
  componentId: "sc-1axebe7-3"
})(["width:300px;box-shadow:0 4px 16px 0 rgba(0,0,0,0.16),0 0 2px 0 rgba(0,0,0,0.08);background-color:#ffffff;overflow:auto;position:relative;top:15px;right:60%;"]);

var Header = function Header(_ref) {
  var children = _ref.children,
      profileLinks = _ref.profileLinks,
      _onProfileLinkClick = _ref.onProfileLinkClick,
      isLoggedIn = _ref.isLoggedIn,
      profileName = _ref.profileName,
      userMessages = _ref.userMessages,
      onClickLogo = _ref.onClickLogo,
      numberUnreadMessages = _ref.numberUnreadMessages;

  var _useState = useState(false),
      isMobileMenuOpen = _useState[0],
      toggleMobileMenu = _useState[1];

  var _useState2 = useState(false),
      isUserProfileMenuOpen = _useState2[0],
      toggleUserProfile = _useState2[1];

  var isMobileViewport = process.browser && window && window.innerWidth < 1024; // Stop scroll when mobile menus are open
  // static is the default value of position in browsers

  isMobileMenuOpen || isUserProfileMenuOpen && isMobileViewport ? process.browser && document && (document.body.style.position = 'fixed') : process.browser && document && (document.body.style.position = 'static');
  var profileMenuContainerRef = useRef(null);
  var profileControlRef = useRef(null); // only use ref for closing profile menu on clickaway at desktop widths

  useOutsideRef(!isMobileViewport ? profileMenuContainerRef : null, !isMobileViewport ? profileControlRef : null);

  function useOutsideRef(profileMenuContainerRef, profileControlRef) {
    function handleClickOutside(event) {
      if (profileMenuContainerRef && profileMenuContainerRef.current && !profileMenuContainerRef.current.contains(event.target) && profileControlRef && profileControlRef.current && !profileControlRef.current.contains(event.target)) {
        toggleUserProfile(false);
      }
    }

    useEffect(function () {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return function () {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  return React__default.createElement(Box, {
    style: {
      height: "" + (isMobileMenuOpen || isUserProfileMenuOpen && isMobileViewport ? '100vh' : '100%'),
      overflow: 'auto'
    }
  }, React__default.createElement(Box, null, React__default.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-around"
  }, React__default.createElement(Container, {
    width: "100%"
  }, React__default.createElement(Flex, {
    px: [15, 15, 20, 30, 30, 40],
    alignItems: "center",
    justifyContent: "center",
    style: {
      height: '60px'
    }
  }, React__default.createElement(Box, {
    flex: 1
  }, React__default.createElement(Hide, {
    lg: true,
    xl: true
  }, React__default.createElement(Box, {
    onClick: function onClick() {
      return toggleMobileMenu(!isMobileMenuOpen);
    }
  }, !isMobileMenuOpen && !isUserProfileMenuOpen && React__default.createElement(SvgAssetMenuIcon, {
    height: 24,
    width: 24,
    style: {
      cursor: 'pointer'
    }
  })))), React__default.createElement(Box, {
    flex: 1
  }, React__default.createElement(Flex, {
    justifyContent: "center"
  }, React__default.createElement(Box, {
    onClick: function onClick() {
      return onClickLogo && onClickLogo();
    },
    style: {
      cursor: 'pointer',
      height: '30px',
      width: '130px'
    }
  }, React__default.createElement(SvgLogo, {
    width: "130px",
    height: "30px"
  })))), React__default.createElement(Box, {
    flex: 1
  }, React__default.createElement(Flex, {
    justifyContent: "flex-end"
  }, React__default.createElement(Hide, {
    xs: true,
    sm: true,
    md: true
  }, React__default.createElement(Box, null, React__default.createElement(Box, {
    id: "user-profile-menu-control",
    ref: profileControlRef,
    onClick: function onClick() {
      toggleUserProfile(!isUserProfileMenuOpen);

      _onProfileLinkClick({
        name: 'user-profile-menu',
        route: ''
      });
    }
  }, React__default.createElement(UserProfileControl, {
    name: profileName,
    isLoggedIn: isLoggedIn,
    numberUnreadMessages: numberUnreadMessages
  })), isUserProfileMenuOpen && React__default.createElement(Box, {
    style: {
      position: 'absolute'
    }
  }, React__default.createElement(UserProfileMenuContainer, {
    bg: "white",
    ref: profileMenuContainerRef
  }, isLoggedIn ? React__default.createElement(UserProfileMenu, {
    profileName: profileName,
    profileLinks: profileLinks,
    onProfileLinkClick: function onProfileLinkClick(profileLink) {
      return _onProfileLinkClick(profileLink);
    },
    userMessages: userMessages,
    numberUnreadMessages: numberUnreadMessages
  }) : React__default.createElement(UserProfileMenuLogIn, {
    onProfileLinkClick: function onProfileLinkClick(profileLink) {
      return _onProfileLinkClick(profileLink);
    }
  }))))), React__default.createElement(Hide, {
    lg: true,
    xl: true
  }, React__default.createElement(Flex, null, !isMobileMenuOpen && !isUserProfileMenuOpen ? React__default.createElement(Box, {
    id: "user-profile-menu-control",
    onClick: function onClick() {
      toggleUserProfile(!isUserProfileMenuOpen);

      _onProfileLinkClick({
        name: 'user-profile-menu',
        route: ''
      });
    }
  }, React__default.createElement(UserProfileControl, {
    name: profileName,
    isLoggedIn: isLoggedIn,
    numberUnreadMessages: numberUnreadMessages
  })) : React__default.createElement(Box, {
    onClick: function onClick() {
      return isMobileMenuOpen ? toggleMobileMenu(!isMobileMenuOpen) : toggleUserProfile(!isUserProfileMenuOpen);
    }
  }, React__default.createElement(CloseIcon, null))))))))), React__default.createElement(Divider$2, null)), React__default.createElement(Box, null, children({
    toggleUserProfile: toggleUserProfile,
    isUserProfileMenuOpen: isUserProfileMenuOpen,
    toggleMobileMenu: toggleMobileMenu,
    isMobileMenuOpen: isMobileMenuOpen
  })));
};

var SvgDownChevron = function SvgDownChevron(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 48 48"
  }, props), createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M0 12l24 24 24-24"
  }));
};

var DownChevronIcon =
/*#__PURE__*/
styled(SvgDownChevron).withConfig({
  displayName: "desktop-header__DownChevronIcon",
  componentId: "sc-1lmjm05-0"
})(["width:12px;height:7px;"]);
var Hover =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "desktop-header__Hover",
  componentId: "sc-1lmjm05-1"
})(["&:hover{", ";}"], function (props) {
  return props.hoverBg && "background-color: " + props.hoverBg;
});
var ActiveIndicator =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "desktop-header__ActiveIndicator",
  componentId: "sc-1lmjm05-2"
})(["width:13px;height:13px;background-color:#13284c;"]);

var PrimaryNav = function PrimaryNav(_ref) {
  var children = _ref.children;
  return React__default.createElement(Box, null, React__default.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center"
  }, React__default.createElement(Container, {
    px: [15, 15, 20, 30, 30, 40],
    width: "100%"
  }, React__default.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    style: {
      height: '50px'
    }
  }, children))), React__default.createElement(Divider$2, {
    color: "#4c5761"
  }));
};

var PrimaryNavLink = function PrimaryNavLink(_ref2) {
  var active = _ref2.active,
      children = _ref2.children,
      title = _ref2.title,
      _onClick = _ref2.onClick,
      route = _ref2.route;

  var _useState = useState(false),
      isSecondaryMenuOpen = _useState[0],
      toggleSecondaryMenu = _useState[1];

  return React__default.createElement(Box, {
    onMouseEnter: function onMouseEnter() {
      return toggleSecondaryMenu(true);
    },
    onMouseLeave: function onMouseLeave() {
      return toggleSecondaryMenu(false);
    }
  }, React__default.createElement(Link, {
    href: route,
    style: {
      cursor: 'pointer',
      textDecoration: 'none'
    },
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick && _onClick();
    }
  }, React__default.createElement(Flex, {
    alignItems: "center"
  }, React__default.createElement(Box, {
    width: "13px"
  }, active ? React__default.createElement(ActiveIndicator, null) : null), React__default.createElement(Box, {
    width: "8px"
  }), React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    color: isSecondaryMenuOpen ? '#df0b0b' : '#5f6367',
    fontWeight: 500,
    fontSize: "13px",
    letterSpacing: "1.5px",
    style: {
      textDecoration: 'none'
    },
    lineHeight: "normal"
  }, title.toUpperCase()))), isSecondaryMenuOpen && React__default.createElement(Box, {
    style: {
      position: 'absolute'
    }
  }, children));
};

var SecondaryNav = function SecondaryNav(_ref3) {
  var children = _ref3.children,
      lastLink = _ref3.lastLink;
  return React__default.createElement(Box, {
    backgroundColor: "#f6f6f7",
    pt: 25,
    pb: 25,
    style: {
      border: 'solid 0.6px #979797',
      position: 'relative',
      top: '18px',
      left: "" + (lastLink ? '-150px' : '-19px')
    },
    width: "280px"
  }, React__default.createElement(Flex, {
    flexDirection: "column"
  }, children));
};

var SecondaryLink = function SecondaryLink(_ref4) {
  var children = _ref4.children,
      route = _ref4.route,
      _onClick2 = _ref4.onClick;
  return React__default.createElement(Link, {
    href: route,
    px: 40,
    my: 15,
    style: {
      cursor: 'pointer',
      textDecoration: 'none'
    },
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick2 && _onClick2();
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: 14,
    color: "#4c5761",
    letterSpacing: "0.7px"
  }, children));
};

var SpecialtySwitcher = function SpecialtySwitcher(_ref5) {
  var specialties = _ref5.specialties,
      handleSelectSpecialty = _ref5.handleSelectSpecialty,
      currentSpecialty = _ref5.currentSpecialty;

  var _useState2 = useState(false),
      isSpecialtyMenuOpen = _useState2[0],
      toggleSepcialtyMenu = _useState2[1];

  var _useState3 = useState(false),
      isSpecialtyMenuHover = _useState3[0],
      toggleSepcialtyMenuHover = _useState3[1];

  var wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        toggleSepcialtyMenu(false);
      }
    }

    useEffect(function () {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return function () {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  return React__default.createElement(Box, {
    ref: wrapperRef,
    onMouseEnter: function onMouseEnter() {
      return toggleSepcialtyMenuHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return toggleSepcialtyMenuHover(false);
    },
    width: "266px",
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Box, {
    onClick: function onClick() {
      return toggleSepcialtyMenu(!isSpecialtyMenuOpen);
    },
    py: "4.5px",
    pl: "21px",
    pr: "13.6px",
    bg: isSpecialtyMenuHover ? 'rgba(76, 87, 97, 0.3)' : 'rgba(76, 87, 97, 0.1)'
  }, React__default.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-between"
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    color: "#5f6367",
    fontWeight: 500,
    fontSize: 13,
    lineHeight: "normal",
    letterSpacing: "1.5px",
    width: "216px"
  }, currentSpecialty.title.toUpperCase()), React__default.createElement(DownChevronIcon, {
    width: "12px"
  }))), isSpecialtyMenuOpen && React__default.createElement(Box, {
    width: "286px",
    style: {
      position: 'absolute'
    }
  }, React__default.createElement(SpecialtySwitcherMenu, {
    handleSelectedSpecialty: function handleSelectedSpecialty(specialty) {
      handleSelectSpecialty && handleSelectSpecialty(specialty);
      toggleSepcialtyMenu(!isSpecialtyMenuOpen);
    },
    selectedSpecialty: currentSpecialty,
    specialties: specialties
  })));
};

var SpecialtySwitcherMenuContainer =
/*#__PURE__*/
styled(Box).withConfig({
  displayName: "desktop-header__SpecialtySwitcherMenuContainer",
  componentId: "sc-1lmjm05-3"
})(["height:441px;width:266px;box-shadow:0 4px 16px 0 rgba(0,0,0,0.16),0 0 2px 0 rgba(0,0,0,0.08);background-color:#ffffff;overflow:auto;position:relative;display:inline-block;top:13.5px;left:-10px;"]);

var SpecialtySwitcherMenu = function SpecialtySwitcherMenu(_ref6) {
  var handleSelectedSpecialty = _ref6.handleSelectedSpecialty,
      selectedSpecialty = _ref6.selectedSpecialty,
      specialties = _ref6.specialties;
  return React__default.createElement(SpecialtySwitcherMenuContainer, {
    pt: "8px",
    mx: 10
  }, specialties.map(function (specialty) {
    return React__default.createElement(Hover, {
      key: specialty.id,
      onClick: function onClick() {
        return handleSelectedSpecialty && handleSelectedSpecialty(specialty);
      },
      hoverBg: "#f6f6f7"
    }, React__default.createElement(Flex, {
      alignItems: "center"
    }, React__default.createElement(Box, {
      width: "12px",
      bg: selectedSpecialty.id === specialty.id ? '#df0b0b' : '#ffffff',
      style: {
        height: '36px'
      }
    }), React__default.createElement(Box, {
      width: "9px"
    }), React__default.createElement(Text, {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 2.29,
      letterSpacing: -0.3,
      color: "#212529"
    }, specialty.title)));
  }));
};

var ButtonOutlined = function ButtonOutlined(_ref) {
  var _onClick = _ref.onClick,
      children = _ref.children;
  return React__default.createElement(Button, {
    onClick: function onClick() {
      return _onClick && _onClick();
    },
    py: "21px",
    width: "100%",
    border: "solid 3px #5f6367",
    bg: "white",
    style: {
      cursor: 'pointer'
    },
    borderRadius: "0px"
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    letterSpacing: "0.36px",
    color: "rgba(0, 0, 0, 0.7)"
  }, children));
};

var RightChevron =
/*#__PURE__*/
styled(SvgDownChevron).withConfig({
  displayName: "mobile-header__RightChevron",
  componentId: "coa9zj-0"
})(["transform:rotate(-90deg);width:16px;height:16px;"]);
var LeftChevron =
/*#__PURE__*/
styled(SvgDownChevron).withConfig({
  displayName: "mobile-header__LeftChevron",
  componentId: "coa9zj-1"
})(["transform:rotate(90deg);width:16px;height:16px;"]);

var MobileMenu = function MobileMenu(_ref) {
  var _onLinkClicked = _ref.onLinkClicked,
      navLinks = _ref.navLinks,
      specialties = _ref.specialties,
      handleSelectSpecialty = _ref.handleSelectSpecialty,
      currentSpecialty = _ref.currentSpecialty,
      isLoggedIn = _ref.isLoggedIn;

  var _useState = useState([]),
      secondaryLinks = _useState[0],
      setSecondaryLink = _useState[1];

  var _useState2 = useState(''),
      selectedItem = _useState2[0],
      setSelectedItem = _useState2[1];

  var _useState3 = useState(false),
      isSecondaryMenuOpen = _useState3[0],
      toggleSecondaryMenu = _useState3[1];

  var _useState4 = useState(false),
      isSpecialtyMenuOpen = _useState4[0],
      toggleSpecialtyMenu = _useState4[1];

  var handleOpenSecondaryMobileMenu = function handleOpenSecondaryMobileMenu(primaryLink) {
    var name = primaryLink.name,
        secondary = primaryLink.secondary;

    if (secondary) {
      setSecondaryLink(secondary);
      setSelectedItem(name);
      toggleSecondaryMenu(true);
    } else {
      setSelectedItem(name);
      toggleSecondaryMenu(false);
      _onLinkClicked && _onLinkClicked(primaryLink);
    }
  };

  return React__default.createElement(Box, {
    px: "15px",
    style: {
      height: '150vh'
    }
  }, React__default.createElement(Box, null, !isSecondaryMenuOpen ? React__default.createElement(MobileSpecialtySwitcher, {
    onClickChangeSpecialty: function onClickChangeSpecialty() {
      toggleSecondaryMenu(true);
      toggleSpecialtyMenu(true);
    },
    onClickSpecialty: function onClickSpecialty() {
      return _onLinkClicked && handleSelectSpecialty(currentSpecialty);
    }
  }, currentSpecialty.title) : React__default.createElement(SecondaryMobileMenuBackItem, {
    onClick: function onClick() {
      toggleSecondaryMenu(false);
      toggleSpecialtyMenu(false);
    }
  }, !isSpecialtyMenuOpen ? selectedItem : currentSpecialty.title)), React__default.createElement(Divider$2, null), !isSecondaryMenuOpen ? React__default.createElement(Box, null, React__default.createElement(Box, null, navLinks.primary.map(function (primaryLink) {
    return React__default.createElement(Box, {
      key: primaryLink.name
    }, React__default.createElement(MobileMenuListItem, {
      route: primaryLink.secondary ? undefined : primaryLink.route,
      onClick: function onClick() {
        return handleOpenSecondaryMobileMenu(primaryLink);
      }
    }, React__default.createElement(PrimaryListItemText, null, primaryLink.name), primaryLink.secondary && React__default.createElement(RightChevron, null)), React__default.createElement(Divider$2, null));
  })), React__default.createElement(Box, {
    style: {
      height: '23px'
    }
  }), React__default.createElement(MobileMenuFooter, {
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked && _onLinkClicked(link);
    },
    mobileFooterLinks: navLinks.mobileMenuFooter,
    isLoggedIn: isLoggedIn
  })) : React__default.createElement(React__default.Fragment, null, React__default.createElement(Box, {
    mt: 30
  }), !isSpecialtyMenuOpen ? secondaryLinks.map(function (secondaryLink) {
    return React__default.createElement(SecondaryMobileMenuListItem, {
      key: secondaryLink.name,
      onClick: function onClick() {
        return _onLinkClicked && _onLinkClicked(secondaryLink);
      }
    }, secondaryLink.name);
  }) : specialties.map(function (specialty) {
    return React__default.createElement(SecondaryMobileMenuListItem, {
      key: specialty.id,
      onClick: function onClick() {
        handleSelectSpecialty && handleSelectSpecialty(specialty);
      }
    }, specialty.title);
  })));
};

var PrimaryListItemText =
/*#__PURE__*/
styled(Text).withConfig({
  displayName: "mobile-header__PrimaryListItemText",
  componentId: "coa9zj-2"
})(["font-family:'Work Sans',sans-serif;font-size:20px;font-weight:600;font-style:normal;font-stretch:normal;line-height:1.1;letter-spacing:-0.38px;color:#212529;"]);

var MobileSpecialtySwitcher = function MobileSpecialtySwitcher(_ref2) {
  var onClickChangeSpecialty = _ref2.onClickChangeSpecialty,
      onClickSpecialty = _ref2.onClickSpecialty,
      children = _ref2.children;
  return React__default.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    py: 30
  }, React__default.createElement(Box, {
    onClick: function onClick() {
      return onClickSpecialty && onClickSpecialty();
    },
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(PrimaryListItemText, null, children)), React__default.createElement(Button, {
    onClick: function onClick() {
      return onClickChangeSpecialty && onClickChangeSpecialty();
    },
    bg: "none",
    border: "solid 1px #1c273f",
    borderRadius: "2px",
    py: "11px",
    px: "14.5px",
    backgroundColor: "white",
    style: {
      cursor: 'pointer'
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 1.38,
    letterSpacing: "-0.3px",
    color: "#1c273f"
  }, "Edit")));
};

var MobileMenuListItem = function MobileMenuListItem(_ref3) {
  var children = _ref3.children,
      _onClick = _ref3.onClick,
      route = _ref3.route;
  return React__default.createElement(Link, {
    href: route && route,
    style: {
      cursor: 'pointer',
      textDecoration: 'none'
    },
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick && _onClick();
    }
  }, React__default.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    py: 30
  }, children));
};

var SecondaryMobileMenuListItem = function SecondaryMobileMenuListItem(_ref4) {
  var children = _ref4.children,
      _onClick2 = _ref4.onClick,
      route = _ref4.route;
  return React__default.createElement(Link, {
    href: route,
    style: {
      cursor: 'pointer',
      textDecoration: 'none'
    },
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick2 && _onClick2();
    }
  }, React__default.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    pl: 50
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    lineHeight: 3.75,
    letterSpacing: "-0.3px",
    color: "#000000"
  }, children)));
};

var SecondaryMobileMenuBackItem = function SecondaryMobileMenuBackItem(_ref5) {
  var children = _ref5.children,
      _onClick3 = _ref5.onClick;
  return React__default.createElement(MobileMenuListItem, {
    onClick: function onClick() {
      return _onClick3 && _onClick3();
    }
  }, React__default.createElement(Flex, {
    alignItems: "center"
  }, React__default.createElement(LeftChevron, null), React__default.createElement(Box, {
    width: 24.5
  }), React__default.createElement(PrimaryListItemText, null, children)));
};

var SecondaryMobileMenu = function SecondaryMobileMenu(_ref6) {
  var children = _ref6.children,
      items = _ref6.items;
  return React__default.createElement(Box, null, React__default.createElement(Divider$2, {
    color: "#4c5761"
  }), items.map(function (item) {
    return React__default.createElement(Box, {
      key: item
    }, children);
  }));
};

var MobileMenuFooter = function MobileMenuFooter(_ref7) {
  var _onLinkClicked2 = _ref7.onLinkClicked,
      mobileFooterLinks = _ref7.mobileFooterLinks,
      isLoggedIn = _ref7.isLoggedIn;
  return React__default.createElement(Box, {
    mb: "30px"
  }, React__default.createElement(Box, null, isLoggedIn ? React__default.createElement(ButtonOutlined, {
    onClick: function onClick() {
      return _onLinkClicked2 && _onLinkClicked2({
        name: 'SignOut',
        route: ''
      });
    }
  }, "Sign Out") : React__default.createElement(Box, null, React__default.createElement(Box, null, React__default.createElement(SignUp, {
    onClick: function onClick() {
      return _onLinkClicked2 && _onLinkClicked2({
        name: 'SignUp',
        route: ''
      });
    }
  })), React__default.createElement(Box, {
    style: {
      height: '54px'
    }
  }), React__default.createElement(Box, {
    onClick: function onClick() {
      return _onLinkClicked2 && _onLinkClicked2({
        name: 'login',
        route: ''
      });
    }
  }, React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.38,
    letterSpacing: "-0.3px",
    color: "#202529",
    textAlign: "center"
  }, "Already have an account,", ' ', React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    as: "span",
    color: "#004577",
    style: {
      textDecoration: 'underline'
    }
  }, "Log in"))))), React__default.createElement(Box, {
    style: {
      height: '30px'
    }
  }), React__default.createElement(Box, {
    my: "1px"
  }, React__default.createElement(Divider$2, null)), React__default.createElement(Box, {
    style: {
      height: '30px'
    }
  }), React__default.createElement(Flex, {
    justifyContent: "center"
  }, React__default.createElement(Box, {
    width: "350px"
  }, React__default.createElement(MobileFooterLinks, {
    mobileFooterLinks: mobileFooterLinks,
    onLinkClicked: function onLinkClicked(link) {
      return _onLinkClicked2(link);
    }
  }))), React__default.createElement(Box, {
    style: {
      height: '30px'
    }
  }), React__default.createElement(Divider$2, null), React__default.createElement(Box, {
    style: {
      height: '30px'
    }
  }), React__default.createElement(Text, {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: "16px",
    lineHeight: 1.31,
    letterSpacing: "-0.7px",
    color: "#4c5761",
    textAlign: "center"
  }, "\xA9 2018 M3 USA Corporation. All Rights Reserved."));
};

var MDLinxHeader = function MDLinxHeader(_ref) {
  var onLinkClicked = _ref.onLinkClicked,
      navLinks = _ref.navLinks,
      specialties = _ref.specialties,
      onSelectSpecialty = _ref.onSelectSpecialty,
      currentSpecialty = _ref.currentSpecialty,
      activePathName = _ref.activePathName,
      isLoggedIn = _ref.isLoggedIn,
      profileName = _ref.profileName,
      userMessages = _ref.userMessages,
      numberUnreadMessages = _ref.numberUnreadMessages;

  var handleLinkClick = function handleLinkClick(link) {
    return onLinkClicked && onLinkClicked(link);
  };

  return React__default.createElement(Header, {
    profileLinks: navLinks.profile,
    onProfileLinkClick: function onProfileLinkClick(profileLink) {
      return handleLinkClick(profileLink);
    },
    isLoggedIn: isLoggedIn,
    profileName: profileName,
    userMessages: userMessages,
    onClickLogo: function onClickLogo() {
      return onLinkClicked && onLinkClicked(navLinks.home);
    },
    numberUnreadMessages: numberUnreadMessages
  }, function (_ref2) {
    var toggleUserProfile = _ref2.toggleUserProfile,
        isUserProfileMenuOpen = _ref2.isUserProfileMenuOpen,
        toggleMobileMenu = _ref2.toggleMobileMenu,
        isMobileMenuOpen = _ref2.isMobileMenuOpen;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(Hide, {
      xs: true,
      sm: true,
      md: true
    }, React__default.createElement(PrimaryNav, null, React__default.createElement(SpecialtySwitcher, {
      specialties: specialties,
      handleSelectSpecialty: function handleSelectSpecialty(specialty) {
        onSelectSpecialty && onSelectSpecialty(specialty);
      },
      currentSpecialty: currentSpecialty
    }), navLinks.primary.map(function (link, i) {
      return React__default.createElement(PrimaryNavLink, {
        key: link.name,
        title: link.name,
        route: link.route,
        onClick: function onClick() {
          return handleLinkClick(link);
        },
        active: link.name === activePathName
      }, link.secondary && React__default.createElement(SecondaryNav, {
        lastLink: navLinks.primary.length - 1 === i
      }, link.secondary.map(function (secondaryLink, i) {
        return React__default.createElement(SecondaryLink, {
          route: secondaryLink.route,
          key: secondaryLink + "-" + i,
          onClick: function onClick() {
            return handleLinkClick(secondaryLink);
          }
        }, secondaryLink.name);
      })));
    }))), React__default.createElement(Hide, {
      lg: true,
      xl: true
    }, isMobileMenuOpen && React__default.createElement(MobileMenu, {
      navLinks: navLinks,
      onLinkClicked: function onLinkClicked(link) {
        handleLinkClick(link);
        toggleMobileMenu(false);
      },
      handleSelectSpecialty: function handleSelectSpecialty(specialty) {
        onSelectSpecialty && onSelectSpecialty(specialty);
        toggleMobileMenu(false);
      },
      specialties: specialties,
      currentSpecialty: currentSpecialty,
      isLoggedIn: isLoggedIn
    }), isUserProfileMenuOpen && (isLoggedIn ? React__default.createElement(Box, {
      style: {
        height: '150vh'
      }
    }, React__default.createElement(UserProfileMenu, {
      profileName: profileName,
      profileLinks: navLinks.profile,
      onProfileLinkClick: function onProfileLinkClick(profileLink) {
        handleLinkClick(profileLink);
        toggleUserProfile(false);
      },
      userMessages: userMessages,
      numberUnreadMessages: numberUnreadMessages
    })) : React__default.createElement(Box, {
      style: {
        height: '110vh'
      }
    }, React__default.createElement(UserProfileMenuLogIn, {
      onProfileLinkClick: function onProfileLinkClick(profileLink) {
        handleLinkClick(profileLink);
        toggleUserProfile(false);
      }
    })))));
  });
};

var NewsArticle = function NewsArticle(_ref) {
  var fields = _ref.fields;
  return createElement("div", null, JSON.stringify(fields));
}; // TODO


var LongFormContent = function LongFormContent(_ref2) {
  var fields = _ref2.fields;
  return createElement("div", null, JSON.stringify(fields));
};

var Entry = function Entry(props) {
  switch (props.contentType) {
    case 'newsArticle':
      return createElement(NewsArticle, {
        fields: props.fields
      });

    case 'longFormContent':
      return createElement(LongFormContent, {
        fields: props.fields
      });
  }
};

var HeaderLinks = {
  home: {
    name: 'home',
    route: 'home'
  },
  primary: [{
    name: 'Journal Summaries',
    route: '/internal-medicine/journal-summaries/'
  }, {
    name: 'News',
    route: '/internal-medicine/top-medical-news/'
  }, {
    name: 'Quizzes',
    route: '/',
    secondary: [{
      name: 'Question of the Day',
      route: '/'
    }, {
      name: 'Monthly Questions',
      route: '/monthly-questions?currentSpec=19'
    }, {
      name: 'Leaderboard',
      route: '/quizzes/leaderboard'
    }, {
      name: 'Archive',
      route: '/quizzes/archive'
    }, {
      name: 'B.E.P',
      route: '/quizzes/bep'
    }]
  }, {
    name: 'Conferences',
    route: '/conferences',
    secondary: [{
      name: 'Find A Conference',
      route: '/conferences/conference'
    }, {
      name: 'Conference Coverage',
      route: '/conferences/coverage'
    }, {
      name: 'Interviews',
      route: '/conferences/interviews'
    }]
  }, {
    name: 'Careers',
    route: '/careers',
    secondary: [{
      name: 'Jobs',
      route: '/careers/jobs'
    }, {
      name: 'Post My CV',
      route: '/careers/cv'
    }, {
      name: 'Search Hospitals',
      route: '/careers/hospitals'
    }, {
      name: 'For Employers',
      route: '/careers/employers'
    }]
  }],
  profile: {
    messages: {
      name: 'My Messages',
      route: '/messages'
    },
    links: [{
      name: 'My Profile Settings',
      route: '/profile'
    }, {
      name: 'My Newsletters Subscriptions',
      route: '/subscriptions'
    }, {
      name: 'My Saved Articles',
      route: '/articles'
    }]
  },
  mobileMenuFooter: [{
    name: 'About MDlinx',
    route: ''
  }, {
    name: 'Privacy Policy',
    route: ''
  }, {
    name: 'Terms of Use',
    route: ''
  }, {
    name: 'Advertise with MDLinx',
    route: ''
  }]
};
var footerLinks = {
  desktop: {
    set1: [{
      name: 'About Us',
      route: ''
    }, {
      name: 'Our Products',
      route: ''
    }, {
      name: 'Site Map',
      route: ''
    }, {
      name: 'FAQs',
      route: ''
    }, {
      name: 'Advertise with MDLinx',
      route: ''
    }],
    set2: [{
      name: 'Contact Us',
      route: ''
    }, {
      name: 'Privacy Policy',
      route: ''
    }, {
      name: 'Terms of Use',
      route: ''
    }]
  },
  mobile: [{
    name: 'About MDlinx',
    route: ''
  }, {
    name: 'Privacy Policy',
    route: ''
  }, {
    name: 'Terms of Use',
    route: ''
  }, {
    name: 'Advertise with MDLinx',
    route: ''
  }]
};
var sdBetaSpecData = [{
  id: 2,
  title: 'Allergy/Immunology',
  site_name: 'allergy-immunology',
  doc_name: 'Allergist',
  __typename: 'ActiveSpecData'
}, {
  id: 3,
  title: 'Anesthesiology',
  site_name: 'anesthesiology',
  doc_name: 'Anesthesiologist',
  __typename: 'ActiveSpecData'
}, {
  id: 19,
  title: 'Cardiology',
  site_name: 'cardiology',
  doc_name: 'Cardiologist',
  __typename: 'ActiveSpecData'
}, {
  id: 114,
  title: 'Dentistry',
  site_name: 'dentistry',
  doc_name: 'Dentist',
  __typename: 'ActiveSpecData'
}, {
  id: 7,
  title: 'Dermatology',
  site_name: 'dermatology',
  doc_name: 'Dermatologist',
  __typename: 'ActiveSpecData'
}, {
  id: 9,
  title: 'Emergency Medicine',
  site_name: 'emergency-medicine',
  doc_name: 'Doctor',
  __typename: 'ActiveSpecData'
}, {
  id: 23,
  title: 'Endocrinology',
  site_name: 'endocrinology',
  doc_name: 'Endocrinologist',
  __typename: 'ActiveSpecData'
}, {
  id: 58,
  title: 'ENT',
  site_name: 'otolaryngology',
  doc_name: 'Otolaryngologist',
  __typename: 'ActiveSpecData'
}, {
  id: 11,
  title: 'Family Medicine',
  site_name: 'family-medicine',
  doc_name: 'Family Physician',
  __typename: 'ActiveSpecData'
}, {
  id: 25,
  title: 'Gastroenterology',
  site_name: 'gastroenterology',
  doc_name: 'Gastroenterologist',
  __typename: 'ActiveSpecData'
}, {
  id: 231,
  title: 'Hospital Administration',
  site_name: 'hospital-administration',
  doc_name: 'Administrator',
  __typename: 'ActiveSpecData'
}, {
  id: 184,
  title: 'Hospitalist',
  site_name: 'hospitalist',
  doc_name: 'Hospitalist',
  __typename: 'ActiveSpecData'
}, {
  id: 29,
  title: 'Infectious Disease',
  site_name: 'infectious-disease',
  doc_name: 'Infectious Disease Expert',
  __typename: 'ActiveSpecData'
}, {
  id: 18,
  title: 'Internal Medicine',
  site_name: 'internal-medicine',
  doc_name: 'Internist',
  __typename: 'ActiveSpecData'
}, {
  id: 121,
  title: 'Medical Student',
  site_name: 'medical-student',
  doc_name: 'Medical Student',
  __typename: 'ActiveSpecData'
}, {
  id: 30,
  title: 'Nephrology',
  site_name: 'nephrology',
  doc_name: 'Nephrologist',
  __typename: 'ActiveSpecData'
}, {
  id: 31,
  title: 'Neurology',
  site_name: 'neurology',
  doc_name: 'Neurologist',
  __typename: 'ActiveSpecData'
}, {
  id: 33,
  title: 'Nurse Practitioner',
  site_name: 'nurse-practitioner',
  doc_name: 'Nurse Practitioner',
  __typename: 'ActiveSpecData'
}, {
  id: 120,
  title: 'Nursing',
  site_name: 'nursing',
  doc_name: 'Nurse',
  __typename: 'ActiveSpecData'
}, {
  id: 48,
  title: 'Obstetrics & Gynecology',
  site_name: 'obstetrics-gynecology',
  doc_name: 'Doctor',
  __typename: 'ActiveSpecData'
}, {
  id: 28,
  title: 'Oncology',
  site_name: 'oncology',
  doc_name: 'Oncologist',
  __typename: 'ActiveSpecData'
}, {
  id: 49,
  title: 'Ophthalmology',
  site_name: 'ophthalmology',
  doc_name: 'Ophthalmologist',
  __typename: 'ActiveSpecData'
}, {
  id: 50,
  title: 'Orthopedics',
  site_name: 'orthopedics',
  doc_name: 'Orthopedist',
  __typename: 'ActiveSpecData'
}, {
  id: 59,
  title: 'Otolaryngology',
  site_name: 'otolaryngology',
  doc_name: 'Otolaryngologist',
  __typename: 'ActiveSpecData'
}, {
  id: 144,
  title: 'Pain Management',
  site_name: 'pain-management',
  doc_name: 'Doctor',
  __typename: 'ActiveSpecData'
}, {
  id: 62,
  title: 'Pathology',
  site_name: 'pathology',
  doc_name: 'Pathologist',
  __typename: 'ActiveSpecData'
}, {
  id: 73,
  title: 'Pediatrics',
  site_name: 'pediatrics',
  doc_name: 'Pediatrician',
  __typename: 'ActiveSpecData'
}, {
  id: 227,
  title: 'Pharmacy',
  site_name: 'pharmacy',
  doc_name: 'Pharmacist',
  __typename: 'ActiveSpecData'
}, {
  id: 228,
  title: 'Pharma News',
  site_name: 'pharma-news',
  doc_name: 'Pharmacist',
  __typename: 'ActiveSpecData'
}, {
  id: 204,
  title: 'Physical Medicine & Rehab',
  site_name: 'physical-medicine-rehab',
  doc_name: 'Physiatrist',
  __typename: 'ActiveSpecData'
}, {
  id: 36,
  title: 'Physician Assistant',
  site_name: 'physician-assistant',
  doc_name: 'Physician Assistant',
  __typename: 'ActiveSpecData'
}, {
  id: 124,
  title: 'Practice Management',
  site_name: 'practice-management',
  doc_name: 'Practice Manager',
  __typename: 'ActiveSpecData'
}, {
  id: 94,
  title: 'Psychiatry',
  site_name: 'psychiatry',
  doc_name: 'Psychiatrist',
  __typename: 'ActiveSpecData'
}, {
  id: 37,
  title: 'Pulmonology',
  site_name: 'pulmonology',
  doc_name: 'Pulmonologist',
  __typename: 'ActiveSpecData'
}, {
  id: 102,
  title: 'Radiology',
  site_name: 'radiology',
  doc_name: 'Radiologist',
  __typename: 'ActiveSpecData'
}, {
  id: 39,
  title: 'Rheumatology',
  site_name: 'rheumatology',
  doc_name: 'Rheumatologist',
  __typename: 'ActiveSpecData'
}, {
  id: 109,
  title: 'Surgery',
  site_name: 'surgery',
  doc_name: 'Surgeon',
  __typename: 'ActiveSpecData'
}, {
  id: 123,
  title: 'Urgent Care',
  site_name: 'urgent-care',
  doc_name: 'Doctor',
  __typename: 'ActiveSpecData'
}, {
  id: 112,
  title: 'Urology',
  site_name: 'urology',
  doc_name: 'Urologist',
  __typename: 'ActiveSpecData'
}];
var userMessages = [{
  companyName: 'Relypsa, Inc.',
  fromName: '',
  id: '398756',
  jobTitle: '',
  jobNumber: '342352',
  numUnread: 7,
  picture: '_lg.jpg',
  priorityFlag: '',
  repId: '17731',
  title: 'Discover a once-daily treatment for hyperkalemia that may lower serum K+ in your patients with CKD with and without heart failure.',
  __typename: 'UserMessage'
}, {
  companyName: '',
  fromName: '',
  id: '399057',
  jobTitle: '',
  jobNumber: '342352',
  numUnread: 5,
  picture: '_lg.jpg',
  priorityFlag: '',
  repId: '6531',
  title: 'For stroke-risk reduction in patients with nonvalvular AF-explore the clinical data of this anticoagulant Rx option.',
  __typename: 'UserMessage'
}, {
  companyName: 'MDLinx',
  fromName: 'Top Read 2017',
  id: '399781',
  jobTitle: '',
  jobNumber: '342352',
  numUnread: 15,
  picture: 'Top-Read-2017-2_lg.jpg',
  priorityFlag: '',
  repId: '18491',
  title: 'Experts say: Most doctors ignore one of the most potent ways to improve health',
  __typename: 'UserMessage'
}];
export { CloseIcon, Container, Divider$2 as Divider, Entry, Footer, GlobalStyle, Header, HeaderLinks, Hide, LongFormContent, MDLinxHeader, MobileMenu, MobileMenuFooter, MobileMenuListItem, MobileSpecialtySwitcher, NewsArticle, PrimaryNav, PrimaryNavLink, SecondaryLink, SecondaryMobileMenu, SecondaryMobileMenuBackItem, SecondaryMobileMenuListItem, SecondaryNav, SpecialtySwitcher, SpecialtySwitcherMenu, UserProfileControl, UserProfileMenu, UserProfileMenuContainer, UserProfileMenuLogIn, footerLinks, sdBetaSpecData, theme, userMessages };